import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export class ConfirmDialogModel {
  constructor(public title: string, public message: string) {
  }
}

@Component({
  selector: 'app-followup-new-appointment',
  templateUrl: './followup-new-appointment.component.html',
  styleUrls: ['./followup-new-appointment.component.css']
})
export class FollowupNewAppointmentComponent implements OnInit {
  title: string;
  message: string;
  selectedOption: string;

  constructor(public dialogRef: MatDialogRef<FollowupNewAppointmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {
  }

  selectOption(type: string): void {
    this.selectedOption = type;
  }

  onContinue(): void {
    if (this.selectedOption) {
      this.dialogRef.close(this.selectedOption);
    }
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
